export type TUiAlertTypes = 'warning' | 'success' | 'info' | 'danger';

export interface IUiAlertContent {
  type: TUiAlertTypes,
  title: string,
  message: string,
  extraMessage?: string
}
